import React, { useState } from "react";
import { MdExpandMore, MdExpandLess, MdWarning } from "react-icons/md";
import { MenuItem } from "../../redux/slices/menuSlice";

interface AllergensSectionProps {
  product: MenuItem;
}

const AllergensSection: React.FC<AllergensSectionProps> = ({ product }) => {
  const [isExpanded, setIsExpanded] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= 640 : false
  );

  if (!product.allergens || product.allergens.length === 0) {
    return null;
  }

  return (
    <section className="mb-6 sm:mb-8 border border-gray-200 rounded-lg overflow-hidden">
      {/* Toggle Button */}
      <button
        type="button"
        aria-expanded={isExpanded}
        aria-controls="allergens-content"
        className="w-full text-left px-3 sm:px-4 py-2 sm:py-3 bg-gray-50 flex items-center justify-between hover:bg-gray-100 transition-colors"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <h2 className="text-lg sm:text-xl font-semibold flex items-center">
          <MdWarning className="h-4 w-4 sm:h-5 sm:w-5 mr-2 text-yellow-600" />
          Allergens
        </h2>
        {isExpanded ? (
          <MdExpandLess className="h-5 w-5 text-gray-500" />
        ) : (
          <MdExpandMore className="h-5 w-5 text-gray-500" />
        )}
      </button>

      {/* Content */}
      {isExpanded && (
        <div
          id="allergens-content"
          className="flex flex-wrap gap-2 p-3 sm:p-4"
        >
          {product.allergens.map((allergen) => (
            <AllergenBadge key={allergen} allergen={allergen} />
          ))}
        </div>
      )}
    </section>
  );
};

interface AllergenBadgeProps {
  allergen: string;
}

const AllergenBadge: React.FC<AllergenBadgeProps> = ({ allergen }) => {
  return (
    <span
      className="px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm bg-yellow-50 
                 text-yellow-800 border border-yellow-200 whitespace-nowrap"
    >
      {allergen}
    </span>
  );
};

export default AllergensSection;
